const rawUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "https://pos.nodedr.com";

export const site = {
  name: "NodeDR POS",
  shortName: "NodeDR POS",
  legalName: "NODEDR INFOTECH PRIVATE LIMITED",
  ownerName: "Raktim Ranjit",
  tagline: "Free, offline-first POS for small retail shops",
  description:
    "NodeDR POS is free, open-source POS software for small retail shops. Run it offline with barcode checkout, inventory, tax billing, thermal printing, and reports using Docker Compose, CasaOS, or the Microsoft Store.",
  url: rawUrl.replace(/\/$/, ""),
  email: "info@nodedr.com",
  nodedrUrl: "https://www.nodedr.com",
  maintainerUrl: "https://github.com/Raktim94",
  repoUrl: "https://github.com/Raktim94/nodedr-pos",
  repoIssuesUrl: "https://github.com/Raktim94/nodedr-pos/issues",
  installerUrl: "https://github.com/Raktim94/nodedr-pos/blob/master/install.sh",
  licenseUrl: "https://github.com/Raktim94/nodedr-pos/blob/master/LICENSE",
  releasesUrl: "https://github.com/Raktim94/nodedr-pos/releases",
  msStoreUrl: "https://apps.microsoft.com/store/detail/9N4D0GW2XZ37?cid=DevShareMCLPCS",
  casaosComposeUrl: "https://raw.githubusercontent.com/Raktim94/nodedr-pos/master/casaos/docker-compose.yml",
  casaosGuideUrl: "https://github.com/Raktim94/nodedr-pos/blob/master/casaos/README.md",
  formName: "NodeDR POS contact",
  submitPath: "/api/submit",
  thankYouPath: "/thank-you",
  ogImage: "/shop-counter.webp",
  port: 1994,
  debVersion: "1.6.2",
  installLinuxUrl: "https://pos.nodedr.com/install-linux.sh",
  debAmd64Url: "/downloads/nodedr-pos-amd64.deb",
  debArm64Url: "/downloads/nodedr-pos-arm64.deb",
} as const;

export function absoluteUrl(path: string): string {
  return new URL(path, site.url).toString();
}
